var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section section-extra-tight"},[_c('div',{staticClass:"section-title"},[_vm._v(" Софтуер ")]),_c('software-list')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }